import React from "react";
import { useNavigate } from "react-router-dom";
import { icons } from "../../Assets/Icons/icons";

const FooterTextLabel = ({ label, text, index }) => {
  return (
    <div
      className={`text-center space-y-2 ${
        index === 2 && "md:col-span-2 lg:col-span-1"
      }`}
    >
      <h6 className="text-secondaryTextColor text-sm xl:text-base capitalize font-bold">
        {label}
      </h6>
      {index === 2 ? (
        <a
          href={`mailto:${text}`}
          className="xl:text-2xl sm:text-xl text-lg font-semibold block hover:text-[#E4E95E] transition-colors duration-300"
        >
          {text}
        </a>
      ) : (
        <h1 className={`xl:text-2xl sm:text-xl text-lg font-semibold`}>
          {text}
        </h1>
      )}
    </div>
  );
};

const UserFooter = () => {
  const footerData = [
    {
      label: "Phone Number:",
      text: "+91 9437062040, +91 9438299105",
    },
    {
      label: "Our Address:",
      text: "N/6 - 274, IRC Village, Opp to IDBI Bank, Jayadev Vihar, Bhubaneswar, Odisha 751015",
    },
    {
      label: "Email Address:",
      text: "sekharbuilders@gmail.com",
    },
  ];

  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <React.Fragment>
      <footer className="bg-[#2a1a05] text-white xl:px-20 px-6">
        <div className="grid lg:grid-cols-3 md:grid-cols-2 items-center gap-5 md:py-20 space-y-4 py-10">
          {footerData.map(({ label, text }, index) => (
            <FooterTextLabel
              key={index}
              label={label}
              text={text}
              index={index}
            />
          ))}
        </div>
        <div className="border-t border-gray-600 text-sm xl:text-base py-5 flex flex-col md:flex-row space-y-4 md:space-y-0 justify-between">
          <div className="text-center md:text-left">
            <span>© {currentYear}</span>
            <span> | </span>
            <span>Sekhar builders</span>
            <span className="ml-2">All Rights Reserved.</span>
            <br />
            <span>Designed & Developed by </span>
            <span
              onClick={() =>
                window.open("https://www.webbocket.com/", "_blank")
              }
              className="text-orange-300 hover:underline hover:text-orange-500 cursor-pointer transition"
            >
              Web_Bocket PVT LTD.
            </span>
          </div>
          <ul className="flex space-x-7">
            <li>
              <span className="xl:text-3xl text-2xl hover:text-[#E4E95B] transition-colors duration-300 cursor-pointer text-gray-600">
                {icons.facebookIcon}
              </span>
            </li>
            <li>
              <span className="xl:text-3xl text-2xl hover:text-[#E4E95B] transition-colors duration-300 cursor-pointer text-gray-600">
                {icons.twitterIcon}
              </span>
            </li>
            <li>
              <span className="xl:text-3xl text-2xl hover:text-[#E4E95B] transition-colors duration-300 cursor-pointer text-gray-600">
                {icons.instagramIcon}
              </span>
            </li>
            <li>
              <span className="xl:text-3xl text-2xl hover:text-[#E4E95B] transition-colors duration-300 cursor-pointer text-gray-600">
                {icons.youtubeIcon}
              </span>
            </li>
          </ul>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default UserFooter;
